import { render } from "./XIconSolidIdentificationBadge.vue?vue&type=template&id=263de29a"
import script from "./XIconSolidIdentificationBadge.vue?vue&type=script&lang=js"
export * from "./XIconSolidIdentificationBadge.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidIdentificationBadge.vue"]])

export default __exports__